<mat-form-field [formGroup]="group"
                [ngClass]="field.styleClass"
                appearance="fill"
                fxFlex>
  <mat-label>{{field?.label}}</mat-label>
  <input matInput
         [formControlName]="field.name"
         type="text"
         [mask]="hesCodeMask"
         [showMaskTyped]="true">
  <ng-container
    *ngFor="let validation of field.validations;"
    ngProjectAs="mat-error">
    <mat-error *ngIf="group.get(field.name)?.hasError(validation.name)"
               [translate]="validation.message"
               [translateParams]="{field:field.label,max:field.maxLength}">
    </mat-error>
  </ng-container>
</mat-form-field>
